import React from 'react';
import { OmitStrict } from '@tanium/coreui-utils';
import { css } from '@tanium/react-emotion';
import { FormInput, FormInputProps } from '@tanium/react-form-input';
import { TextInput } from '@tanium/react-text-input';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Props<TFields = any, K extends keyof TFields = any>
  extends OmitStrict<FormInputProps<TFields, K>, 'children'>,
    React.ComponentPropsWithoutRef<typeof TextInput> {}

export const FormTextInput = React.forwardRef<HTMLInputElement, Props>(
  ({ dataKey, ...rest }, ref) => (
    <FormInput dataKey={dataKey}>
      {({ idForInput, hasErrors, onChange, value = '' }) => (
        <TextInput
          ref={ref}
          className={css({
            width: 400,
          })}
          invalid={hasErrors}
          id={idForInput}
          value={value}
          // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- function depends on parameter passed to inner function
          onChange={(e) => {
            onChange({ value: e.target.value });
          }}
          {...rest}
        />
      )}
    </FormInput>
  ),
);
